var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevIconBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.55273L6.625 8.42773L3.19727 5L6.625 1.57227L5.5 0.447266L0.947266 5L5.5 9.55273Z",
    fill: "#131314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevIconBlack);
export default __webpack_public_path__ + "static/media/prev-icon-black.14d65090c5cb41ef7ea94cac05b1f9c6.svg";
export { ForwardRef as ReactComponent };